import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ApiService, ObservalbeStateService, UtilityService } from 'src/app/@theme/service';
import * as _ from 'lodash';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataStateChangeEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, SortDescriptor, State, process} from '@progress/kendo-data-query';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-edit-product-master',
  templateUrl: './add-edit-product-master.component.html',
  styleUrls: ['./add-edit-product-master.component.scss']
})
export class AddEditProductMasterComponent implements OnInit {
  private ngUnSubscribe: Subject<any> = new Subject();
  isImageSaved: boolean;
  allGridData:any;
  productForm: FormGroup;
  selectedLang:any;
  prod_code:string;
  prodTypeList:any;
  imageFile:any;
  pgType:any;
  uomList:any;
  categoryList:any;
  subCategory:any;
  mode:string;
  formData = [];
  screenData = [];
  isFormValueChanged = true;
  gridata: any;
  multiple = false;
  allowUnsort = true;
  skip = 0;
  pageSize = 5;
  pageSizes = true;
  public gridView: GridDataResult;
  public state: State = {
    skip: 0,
    take: 5,
};
sort: SortDescriptor[] = [
  {
    field: "pg_id",
    dir: "asc",
  },
];
previousNext = true;
position:any = "bottom";
buttonCount = 3;
type:any = "numeric";
  priceGridData: any;
  qualityGridData: any;
  userInfo: any;

  constructor(public fb: FormBuilder, public observable:ObservalbeStateService, private sanitizer:DomSanitizer,
    public api: ApiService, public router: Router, private http: HttpClient, private utility: UtilityService) { 
    this.productForm = this.fb.group({
      prod_type_code:['', Validators.required],
      prod_type_desc:[],
      subcategory_code:['', Validators.required],
      subcategory_desc:[],
      prod_uom:[],
      prod_code:[],
      prod_desc:[],
      prod_gid:[],
      status_desc:[],
      new:[],
      prod_img:[],
      category_desc:[],
      category_code:['', Validators.required],
      farm_prod_flag:['', Validators.required],
      uom_code:['', Validators.required],
      uom_desc:[],
      rowTimestamp:[]
    });
  }

 async ngOnInit() {
    this.selectedLang = JSON.parse(localStorage.getItem('selectedLang'));
    this.userInfo = await JSON.parse(localStorage.getItem('vprpinfo'));
    this.getScreenData();
    this.getProductType();
    // this.getcategory();
    // this.getUom();
    setTimeout(() => {
      this.isFormValueChanged = true;
    }, 1000);
    this.productForm.valueChanges.subscribe(res => {
      if(this.productForm.valid) {
        this.isFormValueChanged = false;
        this.utility.prodMasterValue = this.productForm.value;
      }
    });
  }

  ngAfterViewInit(){
    this.observable.$prodDetails.pipe(takeUntil(this.ngUnSubscribe)).subscribe((res:any) => {
      if(res){
        this.prod_code = res.prodDetails.prod_code;
        this.mode = res.prodDetails.mode;
        if(this.prod_code) {
          setTimeout(() => {
            this.getProdDetails();
          }, 2000);
        }
      }
    });
 }

 public dataStateChange(state: DataStateChangeEvent): void {
  this.state = state;
  this.gridView = process(this.gridata, this.state);
}

pageChange({ skip, take }: PageChangeEvent): void {
this.skip = skip;
this.pageSize = take;
this.loadProduct1();
}

public sortChange(sort: SortDescriptor[]): void {
  this.sort = sort;
  this.gridView = {
    data: orderBy(this.gridata, this.sort),
    total: this.gridata.length,
  };
}

private loadProduct1(): void {
  this.gridView = {  
    data: this.gridata.slice(this.skip, this.skip + this.pageSize),
    total: this.gridata.length,
  };
}



private loadProduct2(): void {
  this.gridView = {  
    data: this.priceGridData.slice(this.skip, this.skip + this.pageSize),
    total: this.priceGridData.length,
  };
}

private loadProduct3():void{
  this.gridView = {  
    data: this.qualityGridData.slice(this.skip, this.skip + this.pageSize),
    total: this.qualityGridData.length,
  };
}

 getProdDetails(){
  this.imageFile = '';
  const reqHeader = {
    "_user_code": this.userInfo? this.userInfo.loginId : '',
    "_user_token": "",
    "_url": '/getProductdtl',
    "_succ_msg": ""
  }
  this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers: this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
    if (res) {
   this.api.get(`/getProductdtl?productCode=${this.prod_code}@${res.myArrayList[0].map._user_token}`).subscribe(async (res:any) =>{
    this.allGridData = res;
    // console.log(`res`, res[1]);
    if(res[1].length > 0) {
      // console.log(`res`, res[1])
      this.gridata = res[1];
      this.loadProduct1();
    } 
    if(res[2].length > 0) {
      this.priceGridData = res[2];
      this.loadProduct2();
    }
    if(res[3].length > 0){
      this.qualityGridData = res[3];
      this.loadProduct3();
    }
     if(res.length > 0){
       const data = res[0][0];
      this.productForm.patchValue(res[0][0]);
      this.productForm.controls[`prod_code`].patchValue('ID-'+data.prod_code)
      this.productForm.controls[`status_desc`].patchValue('Status-'+data.status_desc)
      this.productForm.controls[`new`].patchValue(this.mode == 'New' ? 'Mode-New' : 'Mode-Edit')
      this.productForm.controls[`prod_desc`].patchValue(data.prod_desc);
      // this.productForm.controls[`prod_code`].patchValue(data.prod_code);
      this.productForm.controls[`prod_type_desc`].patchValue(data.prod_type_desc);
      this.productForm.controls[`prod_type_code`].patchValue(data.prod_type_code);
      this.productForm.controls[`category_desc`].patchValue(data.category_desc);
      this.productForm.controls[`category_code`].patchValue(data.category_code);
      this.productForm.controls[`subcategory_desc`].patchValue(data.subcategory_desc);
      this.productForm.controls[`subcategory_code`].patchValue(data.subcategory_code);
      this.productForm.controls[`uom_desc`].patchValue(data.uom_desc);
      this.productForm.controls[`uom_code`].patchValue(data.uom_code);
      this.productForm.controls[`prod_gid`].patchValue(data.prod_gid)
      this.productForm.controls[`farm_prod_flag`].patchValue(data.farm_prod_flag);
      this.productForm.controls[`rowTimestamp`].patchValue(data.row_timestamp);
      //console.log(`rowTimeStamp`, this.productForm.controls[`rowTimestamp`].value);
      this.getSubCategory(data.category_code);
      this.imageFile = data.prod_image;
      // if((data.prod_image == 'null') || (data.prod_image == null)) {
      //   this.imageFile = ''
      // } else if(data.prod_image.startsWith('/')) {
      //   const a = 'data:image/jpg;base64,'+data.prod_image;
      //   this.imageFile = this.sanitizer.bypassSecurityTrustResourceUrl(a)  
      // }
     // console.log(`image file`, this.imageFile)
      this.isFormValueChanged = true;
     }
   });
  }
})
 }

 getProductType(){
  const reqHeader = {
    "_user_code": this.userInfo.loginId,
    "_user_token": "",
    "_url": '/getMasterdesc',
    "_succ_msg": ""
  }
  this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers:          this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
    if (res) {
  this.api.get(`/getMasterdesc?parentCode=${'QCD_PROD_TYPE'}@${res.myArrayList[0].map._user_token}`).subscribe(res =>{
    this.prodTypeList = res[0];
    setTimeout(() => {
      this.getPGType();
    }, 1000);
  });
}
  });
}

getcategory(){
  const reqHeader = {
    "_user_code": this.userInfo.loginId,
    "_user_token": "",
    "_url": '/getMasterdesc',
    "_succ_msg": ""
  }
  this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers:          this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
    if (res) {

  this.api.get(`/getMasterdesc?parentCode=${'QCD_CATEGORY'}@${res.myArrayList[0].map._user_token}`).subscribe(res =>{
    this.categoryList = res[0];
    setTimeout(() => {
      this.getUom();
    }, 1500);
  });
}
  });
}

getPGType(){
  const reqHeader = {
    "_user_code": this.userInfo.loginId,
    "_user_token": "",
    "_url": '/getMasterdesc',
    "_succ_msg": ""
  }
  this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers: this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
    if (res) {

  this.api.get(`/getMasterdesc?parentCode=${'QCD_PG_TYPE'}@${res.myArrayList[0].map._user_token}`).subscribe(res =>{
    this.pgType = res[0];
    setTimeout(() => {
      this.getcategory();
    }, 1500);
  });
}
  });
}

getUom(){
  const reqHeader = {
    "_user_code": this.userInfo.loginId,
    "_user_token": "",
    "_url": '/getMasterdesc',
    "_succ_msg": ""
  }
  this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers:          this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
    if (res) {
  this.api.get(`/getMasterdesc?parentCode=${'QCD_UOM'}@${res.myArrayList[0].map._user_token}`).subscribe(res =>{
    this.uomList = res[0];
  });
}
  });
}

getSubCategory(val:any){
  const reqHeader = {
    "_user_code": this.userInfo.loginId,
    "_user_token": "",
    "_url": '/getMasterdesc',
    "_succ_msg": ""
  }
  this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers:          this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
    if (res) {
  this.api.get(`/getMasterdesc?parentCode=${'QCD_SUBCATEGORY'}&dependCode=${val}@${res.myArrayList[0].map._user_token}`).subscribe(res =>{
    this.subCategory = res[0];
  });
}
  });
}

onSelectProdType(event){
  this.productForm.controls[`prod_type_id`].patchValue(event.target.value);
}

onSelectUOM(event){}

onSelectSubCategory(event){}

onSelectCategory(event){
this.productForm.controls[`category_code`].patchValue(event.target.value);
this.getSubCategory(event.target.value);
}

onselectFarm(val){
  this.productForm.controls[`farm_prod_flag`].patchValue(val.master_code);
}
  done(){
      const formData  = new FormData();
      formData.append('gid', this.mode == 'New' ? 0 : this.productForm.controls[`prod_gid`].value)
      formData.append('prodCode', this.mode == 'New' ? 0 : this.productForm.controls[`prod_code`].value);
      formData.append('prodDesc', this.productForm.controls[`prod_desc`].value);
      formData.append('prodFarmFlag', this.productForm.controls[`farm_prod_flag`].value);
      formData.append('prodTypeCode', this.productForm.controls[`prod_type_code`].value);
      formData.append('prodCategoryCode', this.productForm.controls[`category_code`].value);
      formData.append('prodSubcategoryCode', this.productForm.controls[`subcategory_code`].value);
      formData.append('prodUomCode', this.productForm.controls[`uom_code`].value);
      formData.append('prodImage', this.imageFile);
      formData.append('statusCode', 'A');
      formData.append('userCode', this.userInfo.loginId);
      formData.append('langCode', this.selectedLang.lang_code);
      formData.append('modeFlag', this.mode == 'New' ? 'I' : 'U');
      formData.append('rowTimestamp', this.mode == 'New' ? '' : this.productForm.controls[`rowTimestamp`].value,)
      formData.append('succMsg', '');
      const reqHeader = {
        "_user_code": this.userInfo.loginId,
        "_user_token": "",
        "_url": '/iudProductmst',
        "_succ_msg": ""
      }
      this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers:          this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
        if (res) {  
      this.api.withOutLang(`/iudProductmst@${res.myArrayList[0].map._user_token}`, formData).subscribe(async (res) => {
        if (res['myArrayList'][0].map.errorStatus == "1") {
          this.utility.toaster('Error', res['myArrayList'][0].map.result);
        } else {
          this.utility.toaster('Success', res['myArrayList'][0].map._succ_msg);
          const prodDetails ={
            mode: 'Edit',
            prod_code: res[`myArrayList`][0].map._prod_code,
          }
          this.observable.PRODDetails({prodDetails: prodDetails});
          this.isFormValueChanged = true;
          this.getProductType();
        //  this.getPGType();
        //  this.getcategory();
        //  this.getUom();
        }
      });
    }
  })
  }

  fileChangeEvent(fileInput: any) {
    // this.imageError = null;
    if (fileInput.target.files && fileInput.target.files[0]) {
        // Size Filter Bytes
        const max_size = 20971520;
        const allowed_types = ['image/png', 'image/jpeg'];
        const max_height = 15200;
        const max_width = 25600;

        if (fileInput.target.files[0].size > max_size) {
            // this.imageError =
            //     'Maximum size allowed is ' + max_size / 1000 + 'Mb';

            return false;
        }

        if (!_.includes(allowed_types, fileInput.target.files[0].type)) {
            // this.imageError = 'Only Images are allowed ( JPG | PNG )';
            return false;
        }
        const reader = new FileReader();
        reader.onload = (e: any) => {
          console.log(`e`, e)
            const image = new Image();
            image.src = e.target.result;
            image.onload = rs => {
                const img_height = rs.currentTarget['height'];
                const img_width = rs.currentTarget['width'];

                console.log(img_height, img_width);


                if (img_height > max_height && img_width > max_width) {
                    // this.imageError =
                    //     'Maximum dimentions allowed ' +
                    //     max_height +
                    //     '*' +
                    //     max_width +
                    //     'px';
                    return false;
                } else {
                    const imgBase64Path = e.target.result;
                    this.imageFile = imgBase64Path;
                    this.productForm.controls[`prod_img`].patchValue(this.imageFile)
                    this.isImageSaved = true;
                    // this.previewImagePath = imgBase64Path;
                }
            };
        };

        reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  removeImage() {
    this.imageFile = this.mode == 'New' ? null : this.allGridData[0][0].prod_image;
    this.isImageSaved = false;
}

getScreenData(){
  const reqHeader = {
    "_user_code": this.userInfo.loginId,
    "_user_token": "",
    "_url": '/getScreendata',
    "_succ_msg": ""
  }
  this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers:          this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
    if (res) {
  this.api.get(`/getScreendata?screenCode=${`W11PMFCUD`}@${res.myArrayList[0].map._user_token}`).subscribe((res:any) =>{
    // this.formData = res;
    res.forEach(element => {
      if(element.ctrl_type_code == 'LABEL') {
        this.formData.push(element);
      } if(element.ctrl_type_code == 'GRID'){
        this.screenData.push(element);
      }
    });
  });
}
  });
}

iudgetHeaders(url) {
  let headerValue = {};
  const token = localStorage.getItem(`token`);
    headerValue =  {
      'Content-Type':  'application/json',
      'Content-Security-Policy': "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
      'X-Tenant-Identifier': 'dynamic_lokos',
      'Authorization': token ? 'Bearer ' + token: '',
      'Cache-Control':  'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
      'Pragma': 'no-cache',
      'Expires': '0',
      // "Referrer-Policy": "no-referrer, strict-origin-when-cross-origin",
      // "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
      // "X-Content-Type-Options": "nosniff",
      "X-Frame-Options": "DENY",
      // "X-XSS-Protection": "1; mode=block",
      '_url': url,
      '_user_token': '',
      'userCode': this.userInfo.loginId,
      'roleCode': '',
      'blockCode': '',
  }
    return new HttpHeaders(headerValue);
  }
}
